import React from "react";

const WSMLogo = (props) => {
  const cls1 = {fill: "#141b4d"};
  const cls3 = {fill: "#059669"};
  let styleProps = {};
  if (props?.style) {
    for (const i in props.style) {
      styleProps[i] = props.style[i];
    }
  }


  return (
      <svg style={styleProps} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 1000">
        <polygon style={cls1} points="384.57 529.78 282.47 285.96 273.61 285.96 151.21 574.87 63.98 285.96 20.15 285.96 141.21 686.89 149.18 686.89 278.34 383.53 367.71 597.48 384.57 529.78"/>
        <g>
          <polygon style={cls3} points="469.95 286.08 408.42 553.29 408.42 553.29 408.42 553.3 403.45 574.87 403.36 574.65 387.01 643.7 405.05 686.89 412.98 686.89 513.45 286.08 469.95 286.08"/>
          <polygon style={cls3} points="547.45 474 580.21 340.89 551.23 285.96 544.29 285.96 453.93 686.78 495.15 686.78 547.59 474 547.45 474"/>
        </g>
        <polygon style={cls1} points="903.55 285.96 896.72 285.96 724.81 614.93 602.29 382.73 587.87 438.73 719.09 686.89 730 686.89 880.97 400.16 923.16 686.89 965 686.89 903.55 285.96"/>
      </svg>
  );
};

export default WSMLogo;